import { createContext, useContext, useState } from 'react';

const ProjectContext = createContext(null);

const STORAGE_KEY = 'pj_active_project';

export function ProjectProvider({ children }) {
  const [project, setProject] = useState(() => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const setActiveProject = (data) => {
    if (data) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    setProject(data);
  };

  return (
    <ProjectContext.Provider value={{ project, setActiveProject }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  return useContext(ProjectContext);
}
